import { alert } from '../helpers/rsuite/Alerts';
import { Button } from 'rsuite';
import React, { useState, useEffect } from 'react';

const ButtonSMS = ({ sendSMS, timeDisable, description, telephone, isAllowContinue = true }) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [appearance, setAppearance] = useState('ghost');
    const [countdown, setCountdown] = useState(parseInt(timeDisable));

    // eslint-disable-next-line
    let timeoutId;

    const handleClick = async (e) => {
        try {
            if (isDisabled) {
                return alert('warning', 'Debe esperar al menos un minuto antes de volver a enviar el SMS.');
            }

            setIsLoading(true);

            if (await sendSMS() /* if return with error, in this case false */) {
                // button retry timeout
                setAppearance('disabled');
                setIsDisabled(true);
                timeoutId = setTimeout(() => {
                    setAppearance('ghost');
                    setIsDisabled(false);
                }, timeDisable * 1000);
            }
        }
        catch (error) {
            setIsDisabled(false);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        let intervalId;
        if (isDisabled) {
            intervalId = setInterval(() => {
                setCountdown(countdown => countdown - 1);
            }, 1000);
        }
        else {
            setCountdown(timeDisable);
            clearInterval(intervalId);
        }
        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, [isDisabled]);

    return (
        <Button
            appearance={appearance}
            loading={isLoading}
            onClick={handleClick}
            disabled={!isAllowContinue}
        >
            {isDisabled ? `${description} (${countdown}s)` : description}
        </Button>
    );
};

export default ButtonSMS;
